import { TableColumn } from '@/config/types';

export const getTableColumns = ({
  isMobile,
  hideColumnsForDeleteMode,
}: {
  isMobile: boolean;
  hideColumnsForDeleteMode?: boolean;
}) => {
  const columnsDesktop: TableColumn[] = [
    { name: 'lender_id', label: '', align: 'left', sticky: true, colWidth: '80px' },
    { name: 'id', label: 'MERCHANT_ID_IN_LENDER_CONTEXT', align: 'left', colWidth: '180px' },
    { name: 'channel_id', label: 'CHANNEL_ID_IN_LENDER_CONTEXT', align: 'left', colWidth: '180px' },
    { name: 'agent_id', label: 'AGENT_ID_IN_LENDER_CONTEXT', align: 'left', colWidth: '180px' },
    { name: 'product', label: 'PRODUCT', align: 'left', colWidth: '180px' },
    { name: 'program', label: 'PROGRAM', align: 'left', colWidth: '120px' },
    { name: 'article_type', label: 'ARTICLE', align: 'left', colWidth: '120px' },
    { name: 'created_at', label: 'CREATED_AT_FOR_TABLE', align: 'left', colWidth: '140px' },
    { name: 'more_actions', label: '', align: 'left', colWidth: '24px' },
  ];
  const columnsMobile: TableColumn[] = [
    { name: 'lender_id', label: '', align: 'left', sticky: true, colWidth: '80px' },
    { name: 'id', label: 'ID', align: 'left', colWidth: '180px' },
    { name: 'product', label: 'PRODUCT', align: 'left', colWidth: '180px' },
    { name: 'program', label: 'PROGRAM', align: 'left' },
    { name: 'more_actions', label: '', align: 'left', colWidth: '24px' },
  ];

  const columnsToHideForDeleteMode = ['created_at', 'more_actions'];

  const hideMoreActionsColumnIfNeeded = (columns, hideColumnsForDeleteMode) => {
    if (hideColumnsForDeleteMode) {
      return columns.filter((column) => !columnsToHideForDeleteMode.includes(column.name));
    }
    return columns;
  };

  return isMobile
    ? hideMoreActionsColumnIfNeeded(columnsMobile, hideColumnsForDeleteMode)
    : hideMoreActionsColumnIfNeeded(columnsDesktop, hideColumnsForDeleteMode);
};
